export default "__VITE_ASSET__DXHhvjby__"